module.exports = "<!-- <mat-sidenav-container>\n    <router-outlet></router-outlet>\n</mat-sidenav-container> -->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/layouts/auth/auth-layout.component.html
// module id = ../../../../../src/app/layouts/auth/auth-layout.component.html
// module chunks = main